
import axios from 'axios';



export const  axios_users_login = async(userdata)=>{
    return await axios.post(`/users/login`,{...userdata},{headers: { 'Accept': 'application/json', 'Content-Type': 'application/json'}}) ;
}

export const  axios_users_userauthenticate = async()=>{
    // delete axios.defaults.headers.common["Authorization"];
    return await axios({method:'GET',url:`/users/userauthenticate/`,headers:{ 'Accept': 'application/json', 'Content-Type':'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}`}});
}

export const  axios_users_deleteuser = async(id)=>{
    return await axios.post(`/users/deleteuser`,{'id':id});
}



const headers = { 'Accept': 'application/json', 'Content-Type': 'application/json'   };
export const  axios_users_modifusertarifsauth = async(id,usernotarif)=>{
    return await axios.post(`/users/modifusertarifsauth`,{'id':id,'notarif': usernotarif},{headers:headers});
}

export const  axios_users_changepassword = async(data)=>{
    return await axios.post(`/users/changepassword`,{...data},{headers: { 'Accept': 'application/json', 'Content-Type': 'application/json'}}) ;
}


